<template>
  <el-dialog title="选择采购入库明细（退货）" :visible.sync="visibleInner" width="1100px" append-to-body @close="handleClose">
    <el-alert v-if="!supplierId" type="warning" :closable="false" title="请先在单据上选择供应商" show-icon />
    <el-form v-else :inline="true" :model="query">
      <el-form-item label="入库单号"><el-input v-model="query.stockInCode" size="small" clearable /></el-form-item>
      <el-form-item><el-button size="small" type="primary" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table ref="table" :data="list" border v-loading="loading" height="400" row-key="stockInLineId" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
      <el-table-column prop="stockInCode" label="入库单号" width="130" />
      <el-table-column prop="materialCode" label="产品编码" width="120" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" />
      <el-table-column prop="specs" label="规格" width="100" />
      <el-table-column prop="quantity" label="入库数量" width="100" align="right" />
      <el-table-column prop="remainQuantity" label="可退数量" width="110" align="right" />
      <el-table-column prop="price" label="含税单价" width="100" align="right" />
    </el-table>
    <div class="selected-tip">已选 {{ selectedCount }} 条</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" :disabled="!supplierId" @click="confirmMultiple">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { docGet } from '../../api/erp/doc'

export default {
  props: {
    visible: { type: Boolean, default: false },
    supplierId: { type: String, default: '' },
    excludeReturnId: { type: String, default: '' }
  },
  data() {
    return { visibleInner: false, query: { stockInCode: '' }, list: [], loading: false, selectedMap: {} }
  },
  computed: {
    selectedCount() { return Object.keys(this.selectedMap).length }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.visibleInner = !!val
        if (val && this.supplierId) {
          this.selectedMap = {}
          this.loadList()
        }
      }
    }
  },
  methods: {
    search() { this.loadList() },
    loadList() {
      if (!this.supplierId) return
      this.loading = true
      docGet('/purchase/purchaseReturn/returnableLines', {
        supplierId: this.supplierId,
        stockInCode: this.query.stockInCode,
        excludeReturnId: this.excludeReturnId
      }).then(res => {
        this.list = res.data || []
      }).catch(() => {}).finally(() => { this.loading = false })
    },
    handleSelectionChange(rows) {
      const map = {}
      rows.forEach(row => { map[row.stockInLineId] = row })
      this.selectedMap = map
    },
    confirmMultiple() {
      const rows = Object.values(this.selectedMap)
      if (!rows.length) { this.$message.warning('请至少选择一条明细'); return }
      this.$emit('select-multiple', rows)
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    cancel() {
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    handleClose() { this.$emit('update:visible', false) }
  }
}
</script>

<style scoped>
.selected-tip { margin: 8px 0; color: #606266; font-size: 13px; }
</style>
